import React from "react";
import { Sidebar } from "../Header/Sidebar";
import styles from "./Layout.module.css";

export const Layout = (props) => {
  const { children } = props;
  return (
    <div className="flex-content-end">
      <Sidebar />
      <div className={styles.Routes}>{children}</div>
    </div>
  );
};
